import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './router-hock'


import ToastPlugin from 'vux/src/plugins/toast'
import AlertPlugin from 'vux/src/plugins/alert'
import ConfirmPlugin from 'vux/src/plugins/confirm'
import LoadingPlugin from 'vux/src/plugins/loading'
import {WechatPlugin} from 'vux'
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)



import {SetTitle} from './utils/title'
import {Save,Fetch} from './utils/storage'
Vue.prototype.setTitle = SetTitle
Vue.prototype.save = Save
Vue.prototype.fetch = Fetch

import { library } from '@fortawesome/fontawesome-svg-core'
import { faAddressCard, faCalendarTimes, faCalendarCheck, faIdBadge, faClone, faFileAlt, faCheckCircle, faCircle, faFileArchive, faComments} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faAddressCard,faCalendarTimes,faCalendarCheck, faIdBadge, faClone, faFileAlt,faCheckCircle, faCircle,faFileArchive, faComments)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import FastClick from 'fastclick'
FastClick.attach(document.body)
import {RemSet} from './utils/rem'
RemSet()



Vue.config.productionTip = false



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
